module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_sonho.00340415.png";